// extracted by mini-css-extract-plugin
module.exports = {"menus":"index_menus_hgjo2","icon":"index_icon_3pWhw","title":"index_title_2Nvj-"};